import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../components/tables/tableContext/TableContext";
import {
  RecallScanDataInterface,
  RecallScanSaleInterface,
} from "../../../../redux/interfaces/recall.interface";
import { dateToString, getDateAndTime } from "../../../../utils/dateAndTime";
import {
  getRecallAwbTableData,
  recallClientsTableHeader,
  recallReceivedRowClassName,
  routingExceptionLabels,
} from "../../RecallEntryDetails/components/tableConfigs/recallEntryDetailsTableConfig";

export const recallScanDocumentTableHeader: TableHeaderCategoryConfig[] = [
  ...recallClientsTableHeader.slice(0, 2),
  { value: "routing", label: "Nod / ruta", minW: 200 },
  ...recallClientsTableHeader
    .slice(2)
    .filter((header) => header.value !== "positionCount"),
];

export const getRecallScanDocumentTableData = (
  document: RecallScanDataInterface,
): TableData[] => {
  const pharmacy = document.pharmacyData;
  const routeName =
    pharmacy.routeName ??
    (pharmacy.routingException
      ? routingExceptionLabels[pharmacy.routingException]
      : "-");
  return [
    {
      id: document.idNotification,
      rowClassName:
        document.status === "received" ? recallReceivedRowClassName : undefined,
      crudData: document,
      data: [
        { title: pharmacy.pharmacyName ?? "-" },
        { title: pharmacy.buyerName ?? "-" },
        {
          title: `Nod ATS: ${pharmacy.nodeName ?? "-"}`,
          subtitle: `Ruta: ${routeName}`,
          subtitleClassName: "mt-1",
        },
        {
          title: `Generat: ${getDateAndTime(
            pharmacy.documentGeneratedAt,
            "-",
          )}`,
          subtitle: `Primit: ${getDateAndTime(document.receivedAt, "-")}`,
          subtitleClassName: "mt-1",
        },
        getRecallAwbTableData(pharmacy.awb),
      ],
    },
  ];
};

export const recallScanTableHeader: TableHeaderCategoryConfig[] = [
  { value: "productCode", label: "Cod produs", minW: 130 },
  { value: "lot", label: "Lot", minW: 130 },
  { value: "bbd", label: "Data expirare (BBD)", minW: 150 },
  { value: "invoiceNumber", label: "Factura", minW: 150 },
  { value: "invoiceDate", label: "Data facturii", minW: 130 },
  { value: "soldQuantity", label: "Cantitate vanduta", minW: 140 },
  { value: "soldUnit", label: "UM", minW: 75 },
];

export const getRecallScanTableData = (
  data: RecallScanSaleInterface[],
): TableData[] =>
  data.map((item) => ({
    id: item.idRecallSale,
    crudData: item,
    data: [
      { title: item.productCode },
      { title: item.lot },
      { title: dateToString(item.bbd) },
      { title: item.invoiceNumber },
      { title: dateToString(item.invoiceDate) },
      { title: item.soldQuantity },
      { title: item.soldUnit ?? "-" },
    ],
  }));
